import React, { useState } from 'react';

import type {
  FrapiTeaserItem,
  GodtTeasers,
  Recommendations,
} from '../../../../types/frapi-types.js';
import type { OptionalDataFailed } from '../../../../../core/fetching/index.js';

import Teaser from '../../teasers/Teaser.js';
import { usePulseContext } from '../../../../../core/mandatory-integrations/pulse/PulseProvider.js';
import { frontendConfig } from '../../../../../core/system/config/frontend.server.js';
import { transformGodtToFrapi } from '../helpers.js';

interface RecommendedProps {
  recommendations: Recommendations;
  isMobile: boolean;
  godtTeasers?: GodtTeasers | OptionalDataFailed;
  isRestaurantSection?: boolean;
  hotness?: number;
}

export const isTeaserNewerThanXMonths = (
  teaser: FrapiTeaserItem,
  months: number,
): boolean => {
  const timestampDate = new Date(teaser.publicationDate);
  const currentDate = new Date();
  const dateXMonthsAgo = new Date();
  dateXMonthsAgo.setMonth(currentDate.getMonth() - months);

  return timestampDate >= dateXMonthsAgo;
};

const WEEKEND_GUIDE_TAG_ID = '980c2311-8257-4106-8124-585f3fd54777';

export const Recommended: React.FC<RecommendedProps> = ({
  recommendations,
  godtTeasers,
  isRestaurantSection,
  isMobile,
}) => {
  const [teaserCount, setTeaserCount] = useState(3);
  const { trackClickUIElement } = usePulseContext();

  const handleOnClick = () => {
    trackClickUIElement({
      object: {
        id: `recirculation:see-more-button`,
        name: 'See three more articles',
        elementType: 'Button',
      },
    }).finally(() => setTeaserCount(teaserCount + 3));
  };

  let teasers = recommendations.items.filter((teaser) => {
    return (
      !teaser.tags.some((tag) => tag.id === WEEKEND_GUIDE_TAG_ID) &&
      isTeaserNewerThanXMonths(teaser, 6)
    );
  });

  const hasGodtTeasers =
    godtTeasers && 'items' in godtTeasers && godtTeasers.items.length > 0;

  if (isRestaurantSection && hasGodtTeasers) {
    const formattedGodtTeasers = transformGodtToFrapi(godtTeasers);
    teasers = [
      ...teasers.slice(0, 2),
      formattedGodtTeasers.items[0],
      ...teasers.slice(2),
    ];
  }

  const hasMoreTeasers = teaserCount < teasers.length;

  return (
    <div className="recommended">
      <div className="recommended-wrapper">
        <h4>Fått med deg disse?</h4>
        <div className="articles-wrapper">
          {teasers.slice(0, teaserCount).map((r) => (
            <Teaser
              {...r}
              key={r.id}
              size={isMobile ? 'big' : 'small'}
              lazyLoad={true}
              fullWidthTeaser={false}
            />
          ))}
        </div>
      </div>

      {hasMoreTeasers && (
        <div className="see-more">
          <button onClick={handleOnClick}>
            <img
              src={`${frontendConfig.cdnUrlInternal}/vink/images/icons/plus.svg`}
              alt="Se flere artikler"
            />
            Se flere artikler
          </button>
        </div>
      )}
    </div>
  );
};
